import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { PDFDocument } from 'pdf-lib';
import { urlToArrayBuffer, getImageAsEmbedNew, removeNonAllowedCharactersFromPDF } from 'src/app/utils/utils.common';

@Injectable({
  providedIn: 'root'
})
export class ModivcareReportService {
  
  constructor() { }

  async fillPDF(pdfBuffer: ArrayBuffer, trips, user, driver, fleet, modivcareTripLog): Promise<ArrayBuffer> {
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();

    const company = user.company ? user.company : user;
    const lastIndex = (trips.length) - 1
    const lastTrip = trips[lastIndex]
    const weekendDate = moment(lastTrip.scheduleTime).tz(company.timeZone).endOf('week').format("MM/DD/YYYY")

    if (company) {
      form.getTextField("provider").setText(company.displayName);

      if (company.npi)
        form.getTextField("provider_id").setText(company.npi);

      if (weekendDate) {
        form.getTextField("date").setText(weekendDate + '');
      }
      if (company.state) {
        form.getTextField("state").setText(company.stateCode);
      }


      if (driver) {
        form.getTextField("driver_name").setText(driver.displayName);
      }

      for (const [index, trip] of trips.entries()) {
        if (trip) {
          if (fleet && fleet.vin) {
            form.getTextField("vin" + index).setText((fleet.vin).slice(-6));
          }
          form.getTextField("trip_date" + index).setText(moment(trip.scheduleTime).tz(company.timeZone).format('MM/DD/YYYY'));
          form.getTextField("trip_id" + index).setText(trip.tripId);
          if (trip.priorityClient && trip.priorityClient.displayName) {
            form.getTextField("member_name" + index).setText(trip.priorityClient.displayName);
          }
          if (trip.scheduleTime) {
            form.getTextField("pickup_time" + index).setText(moment(trip.scheduleTime).tz(company.timeZone).format('HH:mm'));
          }
          if (trip.appointmentTime) {
            form.getTextField("dropoff_time" + index).setText(moment(trip.appointmentTime).tz(company.timeZone).format('HH:mm'));
          }
          // form.getTextField("willcall_time" + index).setText('');
          form.getTextField("total_mileage" + index).setText(trip.milage + '');
          // form.getTextField("late_reason" + index).setText('');
          if (trip.preSpecialRate) {
            form.getTextField("amount" + index).setText(trip.preSpecialRate + '');
          }
          if (trip.job) {
            if (trip.job.odometerBegin) {
              form.getTextField("start_odometer" + index).setText(trip.job.odometerBegin);
            }
            if (trip.job.odometerStop) {
              form.getTextField("end_odometer" + index).setText(trip.job.odometerStop);
            }
            if (trip.job.signatureImage) {
              const jpgImageBytes: any = await urlToArrayBuffer(trip.job.signatureImage);
              const pngImage = await getImageAsEmbedNew(pdfDoc, trip.job.signatureImage, jpgImageBytes);
              if (pngImage)
                form.getTextField("signature" + index).setImage(pngImage);
            }

          }
        }
      }


      const jpgImageBytes: any = await urlToArrayBuffer(driver.driverSignatureImage);
      const pngImage = await getImageAsEmbedNew(pdfDoc, driver.driverSignatureImage, jpgImageBytes);
      if (pngImage)
        form.getTextField('driver_signature').setImage(pngImage);
      form.getTextField("driver_name").setText(driver.displayName);
      form.getTextField("driver_license_number").setText(driver.driverLicenseNumber);


    }

    // remove non ASCII
    await removeNonAllowedCharactersFromPDF(form);
    const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
    return modifiedBuffer;
  }

  async getModivcareReport(payload, company, driver, fleet, modivcareTripLog) {
    // return
    const pdfArray = [];
    let newtemp = []
    for (const [index, item] of payload.entries()) {
      newtemp.push(item)
      if (index === 7) {
        const response = await fetch("assets/documents/modivcare-report.pdf");
        let pdfBuffer = await response.arrayBuffer();
        pdfBuffer = await this.fillPDF(pdfBuffer, newtemp, company, driver, fleet, modivcareTripLog);
        pdfArray.push(pdfBuffer);
        newtemp = [];
      } else if (index > 7 && (index - 7) % 8 === 0) {
        const response = await fetch("assets/documents/modivcare-report-blank.pdf");
        let pdfBuffer = await response.arrayBuffer();
        pdfBuffer = await this.fillPDF(pdfBuffer, newtemp, company, driver, fleet, modivcareTripLog);
        pdfArray.push(pdfBuffer);
        newtemp = [];
      }
    }

    if (!pdfArray.length && newtemp.length) {
      const response = await fetch("assets/documents/modivcare-report.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillPDF(pdfBuffer, newtemp, company, driver, fleet, modivcareTripLog);
      pdfArray.push(pdfBuffer);
      newtemp = [];
    } else if (pdfArray.length && newtemp.length) {
      const response = await fetch("assets/documents/modivcare-report-blank.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillPDF(pdfBuffer, newtemp, company, driver, fleet, modivcareTripLog);
      pdfArray.push(pdfBuffer);

    }

    const pdfDoc = await PDFDocument.create();
    for (const pdfBytesData of pdfArray) {
      const sourcePDF = await PDFDocument.load(pdfBytesData);
      const [page] = await pdfDoc.copyPages(sourcePDF, [0]);
      pdfDoc.addPage(page);
    }
    const mergedPdfBytes = await pdfDoc.save();
    if (mergedPdfBytes) {
      const currentDate = moment().format("MM-DD-YYYY");
      const fileName = `modivcare_trip_logs_${currentDate}.pdf`;
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      modivcareTripLog.isLoading = false;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  //TRF
  async fillTrfPDF(pdfBuffer: ArrayBuffer, trips, preFleet, user): Promise<ArrayBuffer> {
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();
    const company = user.company ? user.company : user;
    const lastIndex = (trips.length) - 1
    const lastTrip = trips[lastIndex]



    for (const [index, trip] of trips.entries()) {
      if (trip) {

        form.getTextField("date").setText(moment().format('MM/DD/YYYY'));

        if (trip.priorityClient && trip.priorityClient.displayName) {
          form.getTextField("member_name").setText(trip.priorityClient.displayName);
        }
        if (trip.priorityClient && trip.priorityClient.contactNumber) {
          form.getTextField("member_phone").setText(trip.priorityClient.contactNumber.toString());
        }
        if (trip.driver && trip.driver.legalName) {
          form.getTextField("driver_name").setText(trip.driver.legalName);
        }

        form.getTextField("trip_id").setText(trip.tripId);

        if (trip.tripId.includes("LEG-A")) {
          form.getTextField("leg_type").setText('A');
        }
        else if (trip.tripId.includes("LEG-B")) {
          form.getTextField("leg_type").setText('B');
        }

        else if (trip.tripId.includes("LEG-C")) {
          form.getTextField("leg_type").setText('C');
        }
        else {
          form.getTextField("leg_type").setText('N/A');
        }


        form.getTextField("pu_address").setText(trip.jobOriginAddress);
        form.getTextField("do_address").setText(trip.jobDestinationAddress);
        form.getTextField("pu_date").setText(moment(trip.scheduleTime).tz(company.timeZone).format('MM/DD/YYYY HHmm'));
        form.getTextField("do_date").setText(moment(trip.appointmentTime).tz(company.timeZone).format('MM/DD/YYYY HHmm'));

        form.getTextField("waiting_time").setText('0');
        form.getTextField("trip_miles").setText(trip.milage ? trip.milage.toString() : 'N/A');

        if (trip.job && trip.job.preSpecialRate) {
          form.getTextField("price").setText(trip.job.preSpecialRate);
        }
        form.getTextField("notes").setText(trip.companyNote);

        const fleet = preFleet[trip.job.fleet];

        if (fleet && fleet.losDetails && fleet.losDetails.title) {
          form.getTextField("vehicle_type").setText(fleet.losDetails.title);
        }
        if (fleet && fleet.vin) {
          form.getTextField("vehicle_vin").setText(fleet.vin);
        }
        form.getTextField("printing_date").setText(moment().format('MM/DD/YYYY HHmm'));
        form.getTextField("company_name").setText(company.displayName);
        form.getTextField("company_address").setText(company.address);

        // form.getTextField("driver_sig").setText(trip.driver.driverSignatureImage);
        // form.getTextField("member_sig").setText('121312');
      }
      // Driver signature image
      const jpgImageBytes: any = await urlToArrayBuffer(trip.driver.driverSignatureImage);
      const driverImage = await getImageAsEmbedNew(pdfDoc, trip.driver.driverSignatureImage, jpgImageBytes);
      form.getTextField('driver_sig').setImage(driverImage);
      // memmber signature image
      const jpgImageByte: any = await urlToArrayBuffer(trip.job.signatureImage);
      const memberSignature = await getImageAsEmbedNew(pdfDoc, trip.job.signatureImage, jpgImageByte);
      if (trip.job && trip.job.signatureImage) {
        form.getTextField('member_sig').setImage(memberSignature);
      }

    }



    // remove non ASCII
    await removeNonAllowedCharactersFromPDF(form);
    const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
    return modifiedBuffer;
  }

  async getModivcareTrfReport(payload, preFleet, user, trfLoader) {
    const pdfArray = [];
    let newtemp = []
    for (const [index, item] of payload.entries()) {
      newtemp.push(item)
      if (index === 0) {
        const response = await fetch("assets/documents/modivcare-trf.pdf");
        let pdfBuffer = await response.arrayBuffer();
        pdfBuffer = await this.fillTrfPDF(pdfBuffer, newtemp, preFleet, user);
        pdfArray.push(pdfBuffer);
        newtemp = [];
      } else if (index > 0) {
        const response = await fetch("assets/documents/modivcare-trf-blank.pdf");
        let pdfBuffer = await response.arrayBuffer();
        pdfBuffer = await this.fillTrfPDF(pdfBuffer, newtemp, preFleet, user);
        pdfArray.push(pdfBuffer);
        newtemp = [];
      }
    }

    if (!pdfArray.length && newtemp.length) {
      const response = await fetch("assets/documents/modivcare-trf.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillTrfPDF(pdfBuffer, newtemp, preFleet, user);
      pdfArray.push(pdfBuffer);
      newtemp = [];
    } else if (pdfArray.length && newtemp.length) {
      const response = await fetch("assets/documents/modivcare-trf-blank.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillTrfPDF(pdfBuffer, newtemp, preFleet, user);
      pdfArray.push(pdfBuffer);

    }

    const pdfDoc = await PDFDocument.create();
    for (const pdfBytesData of pdfArray) {
      const sourcePDF = await PDFDocument.load(pdfBytesData);
      const [page] = await pdfDoc.copyPages(sourcePDF, [0]);
      pdfDoc.addPage(page);
    }
    const mergedPdfBytes = await pdfDoc.save();
    if (mergedPdfBytes) {
      const currentDate = moment().format("MM-DD-YYYY");
      const fileName = `modivcare_trf_${currentDate}.pdf`;
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      trfLoader.isLoading = false;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
// ============ Trip Log =====================

async fillTripLogPDF(pdfBuffer: ArrayBuffer, trips, user, driver, fleet, isTripLogLoader, selectedFundingSource): Promise<ArrayBuffer> {
  const pdfDoc = await PDFDocument.load(pdfBuffer);
  const form = pdfDoc.getForm();

  const company = user.company ? user.company : user;
  const lastIndex = (trips.length) - 1
  const lastTrip = trips[lastIndex]
  // const weekendDate = moment(lastTrip.scheduleTime).tz(company.timeZone).endOf('week').format("MM/DD/YYYY")
  const currentDate = moment().tz(company.timeZone).format("MM/DD/YYYY");

  if (selectedFundingSource && selectedFundingSource.profileImageURL) {

    const jpgImageBytes: any = await urlToArrayBuffer(selectedFundingSource.profileImageURL);
    const compnayLogo = await getImageAsEmbedNew(pdfDoc, selectedFundingSource.profileImageURL, jpgImageBytes);
    if (compnayLogo){
      form.getTextField("fs_logo").setImage(compnayLogo);
    }
    
    form.getTextField("provider_name").setText(company.displayName);

    if (company.npi){
      form.getTextField("provider_id").setText(company.npi);
    }

    if (driver) {
      form.getTextField("driver_name").setText(driver.displayName);
    }

      form.getTextField("date").setText(currentDate + '');

    for (const [index, trip] of trips.entries()) {
      if (trip) {
        
        form.getTextField("trip_date" + index).setText(moment(trip.scheduleTime).tz(company.timeZone).format('MM/DD/YYYY'));
        form.getTextField("trip_id" + index).setText(trip.tripId);
        
        if (trip.priorityClient && trip.priorityClient.displayName) {
          form.getTextField("member_name" + index).setText(trip.priorityClient.displayName);
        }

        if (trip.jobOriginAddress) {
          form.getTextField("pu_address" + index).setText(trip.jobOriginAddress);
        }

        if (trip.jobDestinationAddress) {
          form.getTextField("do_address" + index).setText(trip.jobDestinationAddress);
        }

        if (fleet && fleet.vin) {
          form.getTextField("vin" + index).setText((fleet.vin).slice(-6));
        }
        
       
        if (trip.scheduleTime) {
          form.getTextField("pu_time" + index).setText(moment(trip.scheduleTime).tz(company.timeZone).format('HH:mm'));
        }
        
        // actualTime
        if(trip.trackInfoJob && trip.trackInfoJob.jobStarted)
        form.getTextField("act_time" + index).setText(moment(trip.trackInfoJob.jobStarted).tz(company.timeZone).format('HH:mm'));
        
        if(trip.trackInfoJob && trip.trackInfoJob.jobAccepted){
            form.getTextField("started_time" + index).setText(moment(trip.trackInfoJob.jobAccepted).tz(company.timeZone).format('HH:mm'));
        }

        
        if (trip.appointmentTime) {
          form.getTextField("do_time" + index).setText(moment(trip.appointmentTime).tz(company.timeZone).format('HH:mm'));
        }
       

        form.getTextField("miles" + index).setText(trip.milage + '');

        if (fleet && fleet.losDetails && fleet.losDetails.title) {
          form.getTextField("los" +  + index).setText(fleet.losDetails.title);
        }
        

        if (trip.preSpecialRate) {
          form.getTextField("billed_amount" + index).setText(trip.preSpecialRate + '');
        }

        if(trip.authorizationNumber){
          form.getTextField("auth_number" +  + index).setText(trip.authorizationNumber);
        }
       
        
          if (trip.signatureImage) {
            const jpgImageBytes: any = await urlToArrayBuffer(trip.signatureImage);
            const memberSignature = await getImageAsEmbedNew(pdfDoc, trip.signatureImage, jpgImageBytes);
            if (memberSignature)
              form.getTextField("member_sig" + index).setImage(memberSignature);
          }

     
      }
    }

    const jpgImageBytes2: any = await urlToArrayBuffer(driver.driverSignatureImage);
    const driverSignature = await getImageAsEmbedNew(pdfDoc, driver.driverSignatureImage, jpgImageBytes2);
    if (driverSignature){
      form.getTextField('driver_signature').setImage(driverSignature);
    }
  }

  // remove non ASCII
  await removeNonAllowedCharactersFromPDF(form);
  const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
  return modifiedBuffer;
}

async getTripLog(payload, company, driver, fleet , isTripLogLoader, selectedFundingSource) {
  // return
  const pdfArray = [];
  let newtemp = []
  for (const [index, item] of payload.entries()) {
    newtemp.push(item)
    if (index === 7) {
      const response = await fetch("assets/documents/trip-log.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillTripLogPDF(pdfBuffer, newtemp, company, driver, fleet, isTripLogLoader , selectedFundingSource);
      pdfArray.push(pdfBuffer);
      newtemp = [];
    } else if (index > 7 && (index - 7) % 8 === 0) {
      const response = await fetch("assets/documents/trip-log-blank.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillTripLogPDF(pdfBuffer, newtemp, company, driver, fleet, isTripLogLoader , selectedFundingSource);
      pdfArray.push(pdfBuffer);
      newtemp = [];
    }
  }



  if (!pdfArray.length && newtemp.length) {
    const response = await fetch("assets/documents/trip-log.pdf");
    let pdfBuffer = await response.arrayBuffer();
    pdfBuffer = await this.fillTripLogPDF(pdfBuffer, newtemp, company, driver, fleet, isTripLogLoader , selectedFundingSource);
    pdfArray.push(pdfBuffer);
    newtemp = [];
  } else if (pdfArray.length && newtemp.length) {
    const response = await fetch("assets/documents/trip-log-blank.pdf");
    let pdfBuffer = await response.arrayBuffer();
    pdfBuffer = await this.fillTripLogPDF(pdfBuffer, newtemp, company, driver, fleet, isTripLogLoader , selectedFundingSource);
    pdfArray.push(pdfBuffer);

  }

  const pdfDoc = await PDFDocument.create();
  for (const pdfBytesData of pdfArray) {
    const sourcePDF = await PDFDocument.load(pdfBytesData);
    const [page] = await pdfDoc.copyPages(sourcePDF, [0]);
    pdfDoc.addPage(page);
  }
  const mergedPdfBytes = await pdfDoc.save();
  if (mergedPdfBytes) {
    const currentDate = moment().format("MM-DD-YYYY");
    const fileName = `trip-log_${currentDate}.pdf`;
    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    isTripLogLoader.isLoading = false;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}



}
